
export function sth_log(message?: any, ...optionalParams: any[]){
  console.log(message, ...optionalParams);
}